/**
 * Shared canvas utilities — tab types, labels, and key normalization.
 *
 * Extracted from useCanvas.ts, useOrchestration.ts, and InlineCanvas.tsx
 * to provide a single source of truth for tab metadata.
 */

/** Canonical canvas tab keys */
type CanvasTab = 'hpi' | 'pe' | 'assessment_and_plan' | 'notes'

/** Canonical tab labels — includes legacy aliases for backward compatibility */
export const TAB_LABELS: Record<string, string> = {
  hpi: 'HPI',
  pe: 'Physical Exam',
  assessment_and_plan: 'Assessment & Plan',
  ap: 'A&P',  // legacy alias
  notes: 'Notes',
  ipass: 'IPASS',
  custom: 'Custom',
}

const ALL_TABS: CanvasTab[] = ['hpi', 'pe', 'assessment_and_plan', 'notes']

/** Map legacy tab keys (e.g. 'ap') to canonical CanvasTab values */
const LEGACY_TAB_MAP: Record<string, CanvasTab> = {
  ap: 'assessment_and_plan',
  hpi: 'hpi',
  pe: 'pe',
  notes: 'notes',
}

/** Normalize a tab key string to a canonical CanvasTab, or null if unrecognized */
export const normalizeTabKey = (key: string): CanvasTab | null => {
  const lower = key.toLowerCase()
  return LEGACY_TAB_MAP[lower] ?? (ALL_TABS.includes(lower as CanvasTab) ? lower as CanvasTab : null)
}
